import { render, staticRenderFns } from "./RequisitionListView.vue?vue&type=template&id=56786376"
import script from "./RequisitionListView.vue?vue&type=script&lang=js"
export * from "./RequisitionListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports